/**
 * Utility function to compute status text for ActionButtonGroup.
 * Returns the appropriate status message based on loading state.
 *
 * @param isLoading - Whether recommendations are being generated
 * @param itemType - Type of item being generated (e.g., 'keywords', 'negative keywords')
 * @param statusMessage - Status message to show when not loading (e.g., "Generated 3 keywords")
 * @returns The status text to display, or null if none
 */
export function getAIButtonStatus(isLoading: boolean, itemType?: string, statusMessage?: string): string | null {
  if (isLoading) {
    return itemType ? `Generating ${itemType}...` : 'Generating...';
  }
  return statusMessage || null;
}
